import type React from 'react';
import GradientColorPicker from '@atoms/new/GradientColorPicker';

interface RoSColorPickerProps {
  color?: string;
  onChange: (color: string) => void;
  children: React.ReactNode;
  disabled?: boolean;
  disableGradient?: boolean;
  disableOpacity?: boolean;
  showPopoverContent?: boolean;
}
function RoSColorPicker({
  color = '',
  onChange,
  children,
  disabled = false,
  disableGradient = false,
  disableOpacity = false,
  showPopoverContent = true
}: RoSColorPickerProps) {
  return (
    <div
      className={`flex justify-between  items-center ${
        disabled ? 'opacity-50' : ''
      }`}
    >
      <h4 className="text-sm">{children}</h4>
      <div
        className={`flex gap-2 relative ${
          disabled ? 'pointer-events-none' : ''
        }`}
      >
        <GradientColorPicker disableGradient={disableGradient} disableOpacity={disableOpacity} showPopoverContent={showPopoverContent} value={color} onChange={onChange}/>
      </div>
    </div>
  );
}

export default RoSColorPicker;
